export interface Month {
  monthNo: number,
  name: string,
  shortname: string;
  installment?: number;
}

export const MONTHS: Month[] = [
  {
    monthNo: 1,
    name: 'Styczeń',
    shortname: 'Sty',
  },
  {
    monthNo: 2,
    name: 'Luty',
    shortname: 'Lut',
  },
  {
    monthNo: 3,
    name: 'Marzec',
    shortname: 'Mar',
  },
  {
    monthNo: 4,
    name: 'Kwiecień',
    shortname: 'Kwi',
  },
  {
    monthNo: 5,
    name: 'Maj',
    shortname: 'Maj',
  },
  {
    monthNo: 6,
    name: 'Czerwiec',
    shortname: 'Cze',
  },
  {
    monthNo: 7,
    name: 'Lipiec',
    shortname: 'Lip',
  },
  {
    monthNo: 8,
    name: 'Sierpień',
    shortname: 'Sie',
  },
  {
    monthNo: 9,
    name: 'Wrzesień',
    shortname: 'Wrz',
  },
  {
    monthNo: 10,
    name: 'Październik',
    shortname: 'Paź',
  },
  {
    monthNo: 11,
    name: 'Listopad',
    shortname: 'Lis',
  },
  {
    monthNo: 12,
    name: 'Grudzień',
    shortname: 'Gru',
  },
];
